interface TableColumn {
  key: string;
  type: 'string' | 'number' | 'percentage' | 'currency';
}

// Generate headers based on test type
export const getTableHeaders = (isThemeTest: boolean) => [
  'segment name',
  'traffic%',
  'stat. sig.',
  isThemeTest ? 'users' : 'checkouts',
  isThemeTest ? 'CVR' : 'conv. rate',
  'AOV',
  isThemeTest ? 'ARPU' : 'ARPC',
];

export const TABLE_FILTERS = [{ name: 'ARPC', filter: () => true }];

export const TABLE_COLUMNS: TableColumn[] = [
  { key: 'segmentName', type: 'string' },
  { key: 'traffic', type: 'percentage' },
  { key: 'statSig', type: 'percentage' },
  { key: 'checkouts', type: 'number' },
  { key: 'conversionRate', type: 'percentage' },
  { key: 'aov', type: 'currency' },
  { key: 'arpc', type: 'currency' },
];
